import moment, { MomentInput } from "moment-timezone";
import formatTimeRange from "./formatTimeRange";

export function formatTimeslotPopoverSubtitle(
  start: MomentInput,
  end: MomentInput,
  timezone: string,
) {
  return `${moment(start).tz(timezone).format("dddd, MMM D ")}${formatTimeRange(
    start,
    end,
    timezone,
  )}`;
}
